import { ChatCircleDotsIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const CommentEmptyCloud = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <ChatCircleDotsIcon size={Sizes[size]} color={fill} {...rest} />;
};

CommentEmptyCloud.displayName = 'CommentEmptyCloud';
